// extracted by mini-css-extract-plugin
export default {"container":"L3t3W","title":"bQR0k","load":"HyQTJ","description-container":"UUcvA","descriptionContainer":"UUcvA","description":"Sg72X","price":"_5yZT4"};